<template>
  <div class="text-right ">
    <b-row class="align-items-center">


      <div class="col-lg-6 col-md-6  ">
        <b-button
            @click="setDirectoryWrapper()"
            variant="warning"
            size="sm"
            type="button"
            class="mb-2 ml-2">

          <span class="">
          بازگشت
          </span>
        </b-button>

        <b-modal id="upload-file" hide-footer>

          <form @submit.prevent="uploadFiles">

            <form-group class="col text-right Font" :validations="$v.uploadSection.uploadDirectory">
              <div slot-scope="{ errors, invalid }">

                <label class="float-right">انتخاب پوشه</label>
                <b-form-select v-model="uploadSection.uploadDirectory" :options="getDirectories"></b-form-select>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>


            <form-group class="col text-right Font" :validations="$v.uploadSection.selectedFiles">
              <div slot-scope="{ errors, invalid }">

                <label class="col-lg-12 text-right mt-3">انتخاب فایل ها</label>
                <b-form-group>
                  <b-form-file v-model="uploadSection.selectedFiles" multiple id="file-default"></b-form-file>
                </b-form-group>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>

            <!--
            v-if="uploadPercent > 0"
            -->


            <div class="" v-if="uploadPercent > 0">
              <span class="text-center">درصد آپلود شده: %{{ uploadPercent }}</span>
              <div class="progress m-2 ">
                <div class="progress-bar" role="progressbar" :style="{width:`${uploadPercent}%`} " aria-valuenow="25"
                     aria-valuemin="0" aria-valuemax="100"></div>
              </div>


              <!--
                 <span class="btn col-lg-12 mb-2 btn-sm ml-auto mr-auto btn-danger" @click="cancelUpload()">
                              <b-icon icon="x"></b-icon>
                 </span>
                            -->
            </div>


            <b-button type="submit" variant="primary" class="float-right col-lg-12">
              <i class="fas fa-upload"></i>
              <span class="d-none d-sm-inline">
              آپلود
              </span>
            </b-button>

          </form>

        </b-modal>

        <b-button
            v-b-modal.upload-file
            variant="primary"
            size="sm"
            type="button"
            class="mb-2 ml-2">
          <span class="">
          اپلود فایل
          </span>
        </b-button>

        <b-button
            v-b-toggle.create-folder
            variant="primary"
            size="sm"
            type="button"
            class="mb-2 ml-2">
          <span class="">
          ساخت پوشه
          </span>
        </b-button>


        <b-collapse id="create-folder" class="mt-2 mb-4">

          <form-group class="col text-right Font" :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">


              <b-input-group class="mb-3">

                <b-input-group-append>
                  <b-button size="sm" text="ثبت" @click="createDirectory()" variant="success">ثبت</b-button>
                </b-input-group-append>

                <b-form-input v-model="form.name" placeholder="نام پوشه را وارد کنید"></b-form-input>

              </b-input-group>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


        </b-collapse>

      </div>

      <div class="col-lg-6 col-md-6   text-lg-left text-center">
        <dashboard-storage-size/>
      </div>


      <div class="col-12 col-lg-4 col-md-4 my-3">
        <div class="d-inline mx-2" v-if="directoryMode === 'file'">
          <select @change="filterManagerFilterWrapper" v-model="fileManagerFilter" class="custom-select " style="width: 300px">
            <option value="created_at,desc">از جدید به قدیم</option>
            <option value="created_at,asc">از قدیم به جدید</option>
          </select>
        </div>
      </div>

    </b-row>
    <div class="container-fluid flex-column">
      <b-row class=" align-items-end ">
        <b-col v-if="directoryMode === 'directory'" v-for="(directory,index) in getDirectories" :key="index"
               class="text-center cursor_pointer my-1  p-2" lg="2">
          <div class="border radius-20 bg-light p-2">
            <img @click="directoryFiles(directory)" src="../../../../public/folder-icon.png" alt="" style="height: 100px">

            <div class=" d-inline-block   rounded w-100">
              <div class="">
                <p @click="directoryFiles(directory)" class="d-inline-block mx-3 m-0 filename-size">{{ directory }}</p>
                <b-icon @click="removeDirectory(directory)" variant="danger" class="d-inline-block trash-icon-font-size p"
                        icon="trash"></b-icon>
              </div>
            </div>
          </div>

        </b-col>

        <b-col v-if="directoryMode === 'file'" v-for="(file,index) in files" :key="index"
               class="text-center cursor_pointer mx-2 my-2 " lg="2"
               @click="selectFile(file.file)">

         <div class="border radius-20 bg-light p-2 file-manager-content">
           <img class="col-lg-12 mt-3" style="object-fit: contain;height: 80px" :src="file.file" v-if="imageTypes.indexOf(file.file.split('.').slice(-1)[0])!==-1"
                alt="">

           <div v-else>
             <b-icon class="h1" icon="file-earmark"/>
           </div>
           <span dir="ltr" class="text-wrap overflow-wrap  d-block mt-2  filename-size">{{
               file.file.split('/').slice(-1)[0].match(/.{1,4}/g).join('')
             }}</span>

           <div class=" rounded p-1  mt-1">
             <b-icon class="h3 col-6 m-0" @click="destroyFile(file.id)" icon="trash"/>
             <b-icon class="h3 col-6 m-0" @click=" copyToClipBoard(file.file)" icon="link45deg"/>
           </div>

         </div>
        </b-col>

      </b-row>
    </div>

    <b-row v-if="directoryMode === 'file'" class="mt-5">
      <Pagination :meta="meta" :onChangePage="changePage"/>
    </b-row>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";
import FormGroup from "../../components/validator/FormGroup";
import FormErrorsManager from "../../components/validator/FormErrorsManager";
import {required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import DashboardStorageSize from "@/plugin/components/dashboard/DashboardWidget/DashboardStorageSize.vue";

export default {
  name: "FileManager",
  data() {
    return {
      directoryMode: 'directory',
      imageTypes: ['jpg', 'jpeg', 'png', 'webp', 'bin', 'avif'],
      directory: '',
      form: {
        name: "", // directory name
      },
      uploadSection: {
        uploadDirectory: '',
        selectedFiles: [],
      },
      fileManagerFilter: 'created_at,desc'
    }
  },
  validations: {
    form: {
      name: {required, slug}, // directory name
    },
    uploadSection: {
      uploadDirectory: {required},
      selectedFiles: {required},
    }
  },
  components: {DashboardStorageSize, Pagination, FormGroup, FormErrorsManager},
  computed: {
    ...mapGetters({
      files: 'FileManager/getFiles',
      meta: 'FileManager/getPagination',
      getDirectories: "FileManager/getDirectories",
      uploadPercent: "FileManager/getUploadPercent",
    })
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    createDirectory() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$store.dispatch('FileManager/createDirectory', this.form)
      }
    },
    directoryFiles(directory) {
      this.directoryMode = 'file';
      this.directory = directory;
      this.$store.dispatch('FileManager/directoryFiles', {directory: directory, page: 1})
    },
    async setDirectoryWrapper() {
      await this.$store.dispatch('FileManager/setDirectories').then(async (res) => {
        this.directoryMode = 'directory';
      })
    },
    changePage(page) {
      const directory = this.directory
      this.$store.dispatch("FileManager/directoryFiles", {directory: directory, page: page});

    },
    destroyFile(fileId) {
      const form = {id: fileId}
      if (confirm('آیا مطمئن هستید؟')) {
        this.$store.dispatch('FileManager/deleteFile', form)
      }
    },
    copyToClipBoard(value) {

      if (value.split('.').slice(-1)[0] == 'json') {

        value = value.replace(`${findAttributeOnSiteInfo('host')}/storage`, `${findAttributeOnSiteInfo('host')}/api/cors`)

        navigator.clipboard.writeText(value);
      } else {
        navigator.clipboard.writeText(value);
      }


      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    uploadFiles() {
      this.$v.uploadSection.$touch();
      if (!this.$v.uploadSection.$invalid) {
        this.$store.dispatch('FileManager/uploadFiles', this.uploadSection)
      }
    },
    cancelUpload() {
      if (confirm('مطمئن هستید؟')) {
        this.$store.dispatch('FileManager/cancelUpload')
      }
    },
    removeDirectory(directory) {
      if (confirm('از حذف فولد اطمینان دارید؟')) {
        console.log(directory)
        const form = {name: directory}
        this.$store.dispatch('FileManager/removeDirectory', form)
      }

    },
    setFileManagerFilter() {
      this.$store.commit('FileManager/setFilters', {key: 'sort', value: this.fileManagerFilter})
    },
    async filterManagerFilterWrapper() {
      await this.setFileManagerFilter()
      await this.directoryFiles(this.directory)
    },
    selectFile(fileUrl) {
      // ارسال رویداد به والد یا استفاده از Vuex
      this.$emit('file-selected', fileUrl);
    }
  },
  mounted() {
    this.setDirectoryWrapper();
  },
};
</script>
<style scoped>
.cursor_pointer {
  cursor: pointer;
}

.trash-icon-font-size {
  font-size: 25px;
  margin-top: 10px;
}

.overflow-wrap {
  overflow-wrap: break-word;

}

.file-manager-content {
  transition: border-color 0.3s ease;
  border: 2px solid transparent; /* رنگ آبی بوت‌استرپ */
  border-radius: 5px;

}

.file-manager-content:hover {
  border: 2px solid var(--primary) !important; /* رنگ آبی بوت‌استرپ */
  box-sizing: border-box;
}
.filename-size{
  font-size: 13px;
}
</style>
